/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import React from 'react';

export interface ProductCardProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

const ProductCard: React.FC<ProductCardProps> = ({ id, className, children }) => {
  return (
    <ClassNames>
      {({ theme, css, cx }) => (
        <div
          id={id}
          css={cx(
            css({
              border: '1px solid',
              borderColor: theme.palette.divider,
              display: 'flex',
              flexDirection: 'column',
              padding: theme.spacing(2),
            }),
            className,
          )}
        >
          {children}
        </div>
      )}
    </ClassNames>
  );
};

export default ProductCard;
